<div class="sidenav full-hight">
  <div *ngIf="_islog == true; then logSideNav else unLogSideNav"></div>
  <ng-template #logSideNav>
    <app-sidenav-auth-content (close)="Closed($event)"></app-sidenav-auth-content>
  </ng-template>
  <ng-template #unLogSideNav>
    <app-sidenav-offline-content (close)="Closed($event)"></app-sidenav-offline-content>
  </ng-template>
</div>
